/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PerimeterPointDto } from './PerimeterPointDto';
import {
    PerimeterPointDtoFromJSON,
    PerimeterPointDtoFromJSONTyped,
    PerimeterPointDtoToJSON,
    PerimeterPointDtoToJSONTyped,
} from './PerimeterPointDto';

/**
 * 
 * @export
 * @interface CreateZoneRequestDto
 */
export interface CreateZoneRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateZoneRequestDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CreateZoneRequestDto
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateZoneRequestDto
     */
    longitude?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateZoneRequestDto
     */
    isMain?: boolean;
    /**
     * Polygon perimeter points describing the covered area.
     * @type {Array<PerimeterPointDto>}
     * @memberof CreateZoneRequestDto
     */
    perimeter?: Array<PerimeterPointDto> | null;
}

/**
 * Check if a given object implements the CreateZoneRequestDto interface.
 */
export function instanceOfCreateZoneRequestDto(value: object): value is CreateZoneRequestDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateZoneRequestDtoFromJSON(json: any): CreateZoneRequestDto {
    return CreateZoneRequestDtoFromJSONTyped(json, false);
}

export function CreateZoneRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateZoneRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'isMain': json['isMain'] == null ? undefined : json['isMain'],
        'perimeter': json['perimeter'] == null ? undefined : ((json['perimeter'] as Array<any>).map(PerimeterPointDtoFromJSON)),
    };
}

export function CreateZoneRequestDtoToJSON(json: any): CreateZoneRequestDto {
    return CreateZoneRequestDtoToJSONTyped(json, false);
}

export function CreateZoneRequestDtoToJSONTyped(value?: CreateZoneRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'isMain': value['isMain'],
        'perimeter': value['perimeter'] == null ? undefined : ((value['perimeter'] as Array<any>).map(PerimeterPointDtoToJSON)),
    };
}

